import Vue from 'vue'

import Store from '../store/store'
const commonJs = {

}

/**
 * 解析一元二次方程组
 * 设a（ax,ay）  o(ox,oy)  b(bx,by)
 * 斜率 k
 */
commonJs.getDisPoint = function (ax, ay, ox, oy, dis) {
  // 斜率
  let k = (ay - oy) / (ax - ox)
  // y=mx+n
  let m = k
  let n = ay - ax * k

  let a = Math.pow(m, 2) + 1
  let b = -2 * ax + (-2 * (ay - n) * m)
  let c = Math.pow(ax, 2) + Math.pow(ay - n, 2) - Math.pow(dis, 2)
  let res = {}
  res.x1 = (-b - Math.pow(b * b - 4 * a * c, 0.5)) / (2 * a)
  res.y1 = k * res.x1 + n
  res.x2 = (-b + Math.pow(b * b - 4 * a * c, 0.5)) / (2 * a)
  res.y2 = k * res.x2 + n
  return res
}

/**
 * 获取某一点距离另外数组中点最近的点的坐标
 */
commonJs.getClosePoint = function (p, ps) {
  if (ps.length > 1) {
    if (Math.pow(ps[0].x - p.x, 2) + Math.pow(ps[0].y - p.y, 2) < Math.pow(ps[1].x - p.x, 2) + Math.pow(ps[1].y - p.y, 2)) {
      return ps[0]
    } else {
      return ps[1]
    }
  }
}

/**
 * 获取某坐标点根据原点旋转一定角度之后的点
 * 原坐标 p
 * 旋转角度 angle
 * 旋转之后的坐标 pr
 */
commonJs.getRotatePoint = function (p, angle) {
  let pr = {}
  pr.x = p.x * Math.cos(angle) - p.y * Math.sin(angle)
  pr.y = p.x * Math.sin(angle) + p.y * Math.cos(angle)
  return pr
}

/**
 * 获取坐标轴上p点相对于圆心p0的度数，仅针对于canvas画布
 * 圆心坐标p0
 * 任一点p
 */
commonJs.getAngleByPoint = function (p, p0) {
  let ps = {x: p.x - p0.x, y: p.y - p0.y}
  let cs = Math.atan(Math.abs(ps.y) / Math.abs(ps.x)) / (Math.PI / 180)
  if (ps.x > 0) {
    if (ps.y > 0) {
      // 第一象限
      return cs
    } else if (ps.y === 0) {
      return 0
    } else {
      // 第四象限
      return 360 - cs
    }
  } else if (ps.x < 0) {
    if (ps.y > 0) {
      // 第二象限
      return 180 - cs
    } else if (ps.y === 0) {
      return 180
    } else {
      // 第三象限
      return cs + 180
    }
  } else {
    if (ps.y > 0) {
      return 90
    } else if (ps.y < 0) {
      return 270
    }
  }
}

/**
 * 已知，半径，角度，求对应角度下坐标轴的点坐标，圆心坐标（0,0）
 */
commonJs.getPointByAngle = function (radius, ang) {
  let x = Math.cos(ang * Math.PI / 180) * radius
  let y = Math.sin(ang * Math.PI / 180) * radius
  return {x: x, y: y}
}

commonJs.calculateRotate = function (point, degree) {
  let x = point.x * Math.cos(degree * Math.PI / 180) + point.y * Math.sin(degree * Math.PI / 180)
  let y = -point.x * Math.sin(degree * Math.PI / 180) + point.y * Math.cos(degree * Math.PI / 180)
  let relativeOriginPoint = {
    x: Math.round(x * 100) / 100,
    y: Math.round(y * 100) / 100
  }
  return relativeOriginPoint
}
/**
 * 计算两个点间的距离
 */
commonJs.getDisBetween2Point = function (x1, y1, x2, y2) {
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))
}

/**
 * 将角度转换为弧度
 */
commonJs.getRadianByDegrees = function (degrees) {
  var radian = degrees * (Math.PI / 180)
  return radian
}
/**
 * 将角度转换为弧度
 */
commonJs.getArcByRadiusAndAngle = function (radius, angle) {
  return angle * radius
}

/**
 * 将弧度转换为角度
 */
commonJs.getDegreesByRadian = function (radian) {
  var degrees = radian * (180 / Math.PI)
  return degrees
}

/**
 * 已知角度及临边，求对边
 */
commonJs.getXYcoordinate = function (x, angle) {
  var len = x * Math.tan(angle * Math.PI / 180)
  return len
}
/**
 * 已知正切值求度数
 */
commonJs.getInclinationAngle = function (tanChan) {
  return Math.atan(tanChan) / (Math.PI / 180)
}

/**
 * 获取根据度数直角边，通过余弦值求斜边
 */
commonJs.getByCosCoor = function (x, angle) {
  return x / Math.cos(angle * Math.PI / 180)
}

commonJs.getAngleBy2Point = function (x1, y1, x2, y2) {
  return this.getInclinationAngle((y2 - y1) / (x1 - x2))
}

/**
 * 格式化单位
 */
commonJs.getReData = function (data) {
  return data
}

/**
 * 获取根据度数，通过正切值求直角另一条边的长度（被除数的边）
 */
commonJs.getXYcoordinateDividend = function (x, angle) {
  var len = x * Math.tan(angle * Math.PI / 180)
  return len
}
/**
 * 获取根据度数，通过正切值求直角另一条边的长度（除数的边）
 */
commonJs.getXYcoordinateByDividend = function (x, angle) {
  var len = x / Math.tan(angle * Math.PI / 180)
  return len
}
/**
 * 将最大最小范围值与真实值作比较，大于最大取最大，小于最小取最小
 */
commonJs.getMinOrMaxVal = function (val, min, max) {
  if (val < min) {
    return min
  } else if (val > max) {
    return max
  } else {
    return val
  }
}

commonJs.getMoveDisByUnit = function () {
  let unit = Store.state.graph.unit
  let moveDis = 0
  if (unit === 'T_METRE_M' || unit === 'T_MILLIMETER_MM') {
    moveDis = 0.1
  } else if (unit === 'T_INCH_DECIMAL') {
    moveDis = 0.0254
  } else if (unit === 'T_FEET_DECIMAL') {
    moveDis = 0.3048
  } else if (unit === 'T_FEET_FRACTION') {
    moveDis = 0.3
  } else if (unit === 'T_INCH_FRACTION') {
    moveDis = 0.1
  }
  return moveDis
}

/**
 * 根据单位换算值，需要转换成厘米的时候toCmFlag传入true
 */
commonJs.changeUnit = function (value, unit, toCmFlag) {
  var temp
  var n = parseFloat(value)
  var liCom = 1 / 16
  if (isNaN(n)) {
    return value
  }
  if (toCmFlag) {
    switch (unit) {
      case 'T_METRE_M':
        temp = value * 100
        break
      case 'T_MILLIMETER_MM':
        temp = value / 10
        break
      case 'T_FEET_DECIMAL':
        temp = value * 2.54 * 12
        break
      case 'T_INCH_DECIMAL':
        temp = value * 2.54
        break
      case 'T_FEET_FRACTION':
        temp = feetTemp(value)
        break
      case 'T_INCH_FRACTION':
        temp = inchTemp(value)
        break
    }
  } else {
    switch (unit) {
      case 'T_METRE_M':
        temp = getToFixed((value / 100), 3)
        break
      case 'T_MILLIMETER_MM':
        temp = getToFixed((value * 10), 0)
        break
      case 'T_FEET_DECIMAL':
        temp = getToFixed((value / 2.54 / 12), 2)
        break
      case 'T_INCH_DECIMAL':
        temp = getToFixed((value / 2.54), 2)
        break
      case 'T_FEET_FRACTION':
        // let ft = value / 2.54 / 12
        // if (ft <= Store.state.limitData) {
        //   temp = 0 + "'" + ' ' + 0 + '-' + 0 + '/' + 16 + '"'
        //   break
        // }
        // let ftZ = Math.floor(ft)
        // let ftycp = (ft - ftZ) * 12
        // let ycz = Math.floor(ftycp)
        // let fraction = ftycp - ycz
        // let resArr = this.calsFs(fraction)
        // let resArr0 = parseInt(resArr[0])
        // let resArr1 = parseInt(resArr[1])
        // let resArrCalsFs = this.calsFs(resArr0 / resArr1)
        // resArr0 = resArrCalsFs[0].toFixed(0)
        // resArr1 = resArrCalsFs[1].toFixed(0)
        // let inchsTemp = ftZ + "'" + ' ' + ycz + '-' + resArr0 + '/' + resArr1 + '"'
        // if (resArr0 === 0) {
        //   temp = 0
        // } else {
        //   temp = inchsTemp
        // }
        let ins = value / 2.54
        // let ins = Math.round(value / 2.54)
        if (ins <= Store.state.limitData) {
          temp = 0 + "'" + ' ' + 0 + '-' + 0 + '/' + 16 + '"'
          break
        }
        let ftZ = parseInt(ins / 12)
        let ycz = Math.floor((ins / 12 - ftZ) * 12)
        let xsz = (ins / 12 - ftZ) * 12 - ycz
        let resArr0 = Math.round(xsz / liCom)
        if (resArr0 === 16) {
          ycz++
          resArr0 = 0
          if (ycz === 12) {
            ftZ++
            ycz = 0
          }
        }
        let es = reductionTo(resArr0, 16)
        let inchsTemp = ftZ + "'" + ' ' + ycz + '-' + es[0] + '/' + es[1] + '"'
        temp = inchsTemp
        break
      case 'T_INCH_FRACTION':
        let feet = value / 2.54
        if (feet <= Store.state.limitData) {
          temp = 0 + ' ' + 0 + '/' + 16 + '"'
          break
        }
        let feetfractions = 16
        let feetfrain = Math.floor(feet)
        let feetnumerator = Math.round((feet - feetfrain) / (1 / feetfractions))
        let feetdenominator = feetfractions
        let feetsTemp = 0
        while ((feetnumerator % 2 === 0) && ((feetdenominator % 2 === 0))) {
          feetnumerator /= 2
          feetdenominator /= 2
        }
        if (feetnumerator === 1 && feetdenominator === 1) {
          feetfrain += 1
          feetnumerator = 0
        }
        if (feetfrain > 0) {
          feetsTemp = feetfrain
        } else {
          feetsTemp = ''
        }
        if (feetnumerator > 0) {
          if (feetfrain > 0) {
            feetsTemp += ' '
          }
          feetsTemp += feetnumerator.toFixed(0) + '/' + feetdenominator.toFixed(0) + '"'
        } else {
          feetsTemp += '"'
        }
        if (feetsTemp === '"') {
          temp = 0.00
        } else {
          temp = feetsTemp
        }
        break
    }
  }
  return temp
}

function getToFixed (value, tip) {
  value = Number(value.toFixed(tip))
  value = value === 0 ? 0 : value
  return value.toFixed(tip)
}

/**
 * 将分数约分方法
 * m,n为正整数的分子和分母
 */
function reductionTo (m, n) {
  var arr = []
  if (!isInteger(m) || !isInteger(n)) {
    console.log('m和n必须为整数')
    return
  }
  var a = m
  var b = n
  if (a >= b) {
    a = m
    b = n
  } else {
    a = n
    b = m
  }
  if (m !== 1 && n !== 1) {
    for (var i = b; i >= 2; i--) {
      if (m % i === 0 && n % i === 0) {
        m = m / i
        n = n / i
      }
    }
  }
  arr[0] = m
  arr[1] = n
  return arr
}

// 判断一个数是否为整数
function isInteger (obj) {
  return obj % 1 === 0
}

// inch分数转cm
function inchTemp (value) {
  if (value * 1 === 0) {
    return 0
  }
  if (value.indexOf("'") > 0) {
    return ''
  }
  let inchFrain = value.split('"')[0].split(' ')
  if (inchFrain.length < 2) {
    return inchFrain[0] * 2.54
  }
  let inchFraction = inchFrain[1].split('/')
  let inchDecimal = inchFraction[0] / inchFraction[1] * 2.54
  return inchDecimal + inchFrain[0] * 2.54
}
// feet分数转cm
function feetTemp (value) {
  if (value * 1 === 0) {
    return 0
  }
  if (value.indexOf("'") === -1 || value.indexOf('-') === -1 || value.indexOf('/') === -1 || value.indexOf('"') === -1) {
    return ''
  }
  let feetFrain = value.split("'")
  let feetFraction = feetFrain[1].split('"')[0].split('-')
  let feetFrac = feetFraction[1].split('/')
  let feetFs = feetFraction[0].split(' ')
  let feetDecimal = feetFrain[0] * 1 + (feetFs[1] * 1 + feetFrac[0] / feetFrac[1]) / 12
  return feetDecimal * 2.54 * 12
}

commonJs.calsFs = function (m) {
  m = m * 100
  let n = 100
  let arr = []
  let a = m
  let b = n
  if (a >= b) {
    a = m
    b = n
  } else {
    a = n
    b = m
  }
  if (m !== 1 && n !== 1) {
    for (let i = b; i >= 2; i--) {
      if (m % i === 0 && n % i === 0) {
        m = m / i
        n = n / i
      }
    }
  }
  arr[0] = m
  arr[1] = n
  return arr
}

commonJs.changeUnitDraw = function (value, unit, toCmFlag) {
  let data = this.changeUnit(value, unit, toCmFlag)
  let unitT = this.changeUnit(unit)
  if (unitT === 'T_FEET_FRACTION') {
    return this.checkData(feetTemp(data)) ? '' : data
  } else if (unitT === 'T_INCH_FRACTION') {
    return this.checkData(inchTemp(data)) ? '' : data
  } else {
    return this.checkData(data) ? '' : data
  }
}
commonJs.checkData = function (data) {
  if (!Number(data)) {
    return true
  } else if (Number(data) === 0) {
    return true
  } else if (Number(data) < 0) {
    return true
  } else {
    return false
  }
}

commonJs.findLensInfo = function (modelData) {
  let selectedModelHCode = modelData.code
  let data
  let matchingLensID = []
  if (modelData.lensExchange) {
    matchingLensID = Vue.prototype.OptionLensList.find(
      item => item.code === selectedModelHCode
    ).lenses
    data = this.findLensDataByIdAndSize(modelData.standardLens, modelData.lcdSize)
  } else {
    matchingLensID = []
    data = this.findLensDataByHCode(selectedModelHCode)
  }
  return {'matchingLensID': matchingLensID, 'selectedLensInfo': data}
}

// 可换镜头数据筛选
commonJs.findLensDataByIdAndSize = function (id, size) {
  let jsonData = Vue.prototype.OptionLensSpec.find(item => (item.id === id && item.lcdSize === size))
  let data
  if (jsonData) {
    data = this.constuctLensData(jsonData)
  }
  return data
}
// 不可换镜头数据筛选
commonJs.findLensDataByHCode = function (code) {
  let jsonData = Vue.prototype.ProjectorLensSpec.find(item => item.code === code)
  let data
  if (jsonData) {
    data = this.constuctLensData(jsonData)
  }
  return data
}

commonJs.findCurrentDistInfo = function (lensData) {
  let value = lensData.lcd.distInfo.find(item => item.ratio === Store.state.aspectRatio)
  return value
}
commonJs.findResolutionByKey = function (resoKey) {
  let value = Store.state.resolutionOptions.find(item => item.key === resoKey)
  return value
}

// 已知对象的value, 返回其key值
commonJs.findKey = (obj, value, compare = (a, b) => a === b) => {
  if (!obj) {
    console.log('findKey error!')
  }
  return Object.keys(obj).find(k => compare(obj[k], value))
}
commonJs.constuctLensData = function (data) {
  let value = {}
  let infoArr = this.findInfoByRatio(data)
  let distInfo = this.createDistInfo(infoArr)
  value['code'] = data['code']
  value['id'] = data['id']
  value['url'] = data['url']
  value['fNum'] = data['fNum']
  value['focalLength'] = data['focalLength']
  value['dimension'] = data['dimension']
  value['zoomRatio'] = data['zoomRatio']
  value['throwRatio'] = data['throwRatio']
  value['lcdSize'] = data['lcdSize']
  value['name'] = data['name']
  value['discontinued'] = data['discontinued']
  value['mu'] = data['mu'] / 10
  value['up'] = data['up'] / 10
  value['fe'] = data['fe'] / 10
  value['lx'] = data['lx'] / 10
  value['lens2mptsHeight'] = data['lens2mptsHeight'] / 10
  value['mpts2wallBottomHeight'] = data['mpts2wallBottomHeight'] / 10

  value['HConcaveMin'] = data['HConcaveMin']
  value['HConcaveMax'] = data['HConcaveMax']
  value['HConvexMin'] = data['HConvexMin']
  value['HConvexMax'] = data['HConvexMax']
  value['VConcaveMin'] = data['VConcaveMin']
  value['VConcaveMax'] = data['VConcaveMax']
  value['VConvexMin'] = data['VConvexMin']
  value['VConvexMax'] = data['VConvexMax']
  value['AutoHConcaveMin'] = data['AutoHConcaveMin']
  value['AutoHConcaveMax'] = data['AutoHConcaveMax']
  value['AutoHConvexMin'] = data['AutoHConvexMin']
  value['AutoHConvexMax'] = data['AutoHConvexMax']

  if (data['weight']) {
    value['weight'] = data['weight'].substring(0, data['weight'].length - 1) / 1000
  }
  value['lcd'] = {
    'aspectRatio': data['aspectRatio'],
    'distInfo': distInfo,
    'lensShiftRange': {
      'v': {
        'min': Math.abs(data['lensShiftVMin']) < 1 ? data['lensShiftVMin'] : data['lensShiftVMin'] / 100,
        'max': Math.abs(data['lensShiftVMax']) < 1 ? data['lensShiftVMax'] : data['lensShiftVMax'] / 100
      },
      'h': {
        'min': Math.abs(data['lensShiftHMin']) < 1 ? data['lensShiftHMin'] : data['lensShiftHMin'] / 100,
        'max': Math.abs(data['lensShiftHMax']) < 1 ? data['lensShiftHMax'] : data['lensShiftHMax'] / 100
      },
      'hv': {
        'min': Math.abs(data['lensShiftHvMin']) < 1 ? data['lensShiftHvMin'] : data['lensShiftHvMin'] / 100,
        'max': Math.abs(data['lensShiftHvMax']) < 1 ? data['lensShiftHvMax'] : data['lensShiftHvMax'] / 100
      }
    }
  }
  return value
}
commonJs.findInfoByRatio = function (data) {
  if (!data) {
    console.log('findInfoByRatio error')
  }
  let keys = Object.keys(data)
  let num = this.findRatioNum(data)
  let info = []
  for (let i = 0; i < num; i++) {
    let infoData = {}
    keys.forEach((item) => {
      if (item.charAt(item.length - 1) === String(i + 1)) {
        infoData[item.substr(0, item.length - 1)] = data[item]
      }
    })
    info.push(infoData)
  }
  return info
}
commonJs.createDistInfo = function (data) {
  let distInfo = []
  for (let i = 0; i < data.length; i++) {
    let val = data[i]
    // if (val['ratio'] !== '-' && val['ratio'] !== '') {
    let distInfoVal = {}
    distInfoVal = {
      'ratio': val['ratio'],
      'throwRange': {
        'w': {
          'min': val['disWMin'],
          'max': val['disWMax']
        },
        't': {
          'min': val['disTMin'],
          'max': val['disTMax']
        }
      },
      'size2dist': {
        'w': {
          'a': val['s2dWa'],
          'b': val['s2dWb']
        },
        't': {
          'a': val['s2dTa'],
          'b': val['s2dTb']
        }
      },
      'dist2size': {
        'w': {
          'a': val['d2sWa'],
          'b': val['d2sWb']
        },
        't': {
          'a': val['d2sTa'],
          'b': val['d2sTb']
        }
      },
      'screenSize': {
        'w': {
          'min': val['sizeWMin'],
          'max': val['sizeWMax']
        },
        't': {
          'min': val['sizeTMin'],
          'max': val['sizeTMax']
        },
        'wall': {
          'min': val['wallMin'],
          'max': val['wallMax']
        }
      },
      'v1b': {
        'w': {
          'a': val['v1bWa'],
          'b': val['v1bWb']
        }
      },
      'wv': {
        'wv1': val['wv1'],
        'wv2': val['wv2']
      },
      'tv': {
        'tv1': val['tv1'],
        'tv2': val['tv2']
      },
      'whiteboardSize': {
        'min': val['whiteboardSizeMin'],
        'intOnMax': val['whiteboardSizeMax'],
        'intOffMax': val['sizeWMax']
      }
    }
    distInfo.push(distInfoVal)
    // }
  }
  return distInfo
}

commonJs.findRatioNum = function (data) {
  let keys = Object.keys(data)
  let arr = []
  keys.forEach((item) => {
    let val = item.charAt(item.length - 1)
    let num = val.match(/\d/g)
    if (num) {
      arr.push(num[0] * 1)
    }
  })
  let maxVal = Math.max.apply(Math, arr)
  return maxVal
}

commonJs.findSpecInfoByRatio = function (ratio, data) {
  let distInfo = data.lcd.distInfo.find(
    item => item.ratio === ratio
  )
  return distInfo
}

commonJs.getPjImgUrl = function (view, type, selectedLensData) {
  let pre = 'P2-'
  let suf = 'front'
  let ceiling = ''

  switch (type) {
    case 0:
      pre = 'P2-'
      break
    case 1:
      pre = 'P1-'
      break
    case 2:
      pre = 'P3-'
      break
    default:
      break
  }
  if (Store.state.selectedModelData.lensExchange && selectedLensData && selectedLensData.id && selectedLensData.id.indexOf('LX') > -1) {
    pre = 'P3-'
  }

  switch (view) {
    case 'sideView':
      suf = 'side'
      break
    case 'frontView':
      suf = 'front'
      break
    case 'topView':
      suf = 'top'
      break
    default:
      break
  }
  if (Store.state.position === 1) {
    ceiling = '_v'
  }
  return 'static/img/' + pre + suf + ceiling + '.png'
}

commonJs.toNumber = (val) => {
  var n = parseFloat(val)
  return isNaN(n) ? val : n
}

commonJs.getThrowRangeDiv = (length) => {
  let throwRangeDiv = []
  for (let i = 0; i < length; i++) {
    throwRangeDiv.push({
      id: i
    })
  }
  return throwRangeDiv
}

commonJs.isInPolygon = (checkPoint, polygonPoints) => {
  var counter = 0
  var i
  var xinters
  var p1, p2
  var pointCount = polygonPoints.length
  p1 = polygonPoints[0]

  for (i = 1; i <= pointCount; i++) {
    p2 = polygonPoints[i % pointCount]
    if (
      checkPoint[0] > Math.min(p1[0], p2[0]) &&
          checkPoint[0] <= Math.max(p1[0], p2[0])
    ) {
      if (checkPoint[1] <= Math.max(p1[1], p2[1])) {
        if (p1[0] !== p2[0]) {
          xinters =
                      (checkPoint[0] - p1[0]) *
                          (p2[1] - p1[1]) /
                          (p2[0] - p1[0]) +
                      p1[1]
          if (p1[1] === p2[1] || checkPoint[1] <= xinters) {
            counter++
          }
        }
      }
    }
    p1 = p2
  }
  if (counter % 2 === 0) {
    return false
  } else {
    return true
  }
}

// 判断点p在当前多边形内部（包括边上）
commonJs.rayCastingByxz = (p, poly) => {
  var px = parseInt(p.x)
  var py = parseInt(p.z)
  var flag = false
  for (var i = 0, l = poly.length, j = l - 1; i < l; j = i, i++) {
    var sx = parseInt(poly[i].x)
    var sy = parseInt(poly[i].z)
    var tx = parseInt(poly[j].x)
    var ty = parseInt(poly[j].z)
    // 点与多边形顶点重合
    if ((sx === px && sy === py) || (tx === px && ty === py)) {
      return 'on'
    }
    // 判断线段两端点是否在射线两侧
    if ((sy < py && ty >= py) || (sy >= py && ty < py)) {
      // 线段上与射线 Y 坐标相同的点的 X 坐标
      var x = sx + (py - sy) * (tx - sx) / (ty - sy)
      // 点在多边形的边上
      if (x === px) {
        return 'on'
      }
      // 射线穿过多边形的边界
      if (x > px) {
        flag = !flag
      }
    }
  }
  // 射线穿过多边形边界的次数为奇数时点在多边形内
  return flag ? 'in' : 'out'
}
// 判断点p在当前多边形内部（包括边上）
commonJs.rayCastingByxy = (p, poly) => {
  var px = parseInt(p.x)
  var py = parseInt(p.y)
  var flag = false
  for (var i = 0, l = poly.length, j = l - 1; i < l; j = i, i++) {
    var sx = parseInt(poly[i].x)
    var sy = parseInt(poly[i].y)
    var tx = parseInt(poly[j].x)
    var ty = parseInt(poly[j].y)
    // 点与多边形顶点重合
    if ((sx === px && sy === py) || (tx === px && ty === py)) {
      return 'on'
    }
    // 判断线段两端点是否在射线两侧
    if ((sy < py && ty >= py) || (sy >= py && ty < py)) {
      // 线段上与射线 Y 坐标相同的点的 X 坐标
      var x = sx + (py - sy) * (tx - sx) / (ty - sy)
      // 点在多边形的边上
      if (x === px) {
        return 'on'
      }
      // 射线穿过多边形的边界
      if (x > px) {
        flag = !flag
      }
    }
  }
  // 射线穿过多边形边界的次数为奇数时点在多边形内
  return flag ? 'in' : 'out'
}
// 判断点p在当前多边形内部（包括边上）
commonJs.rayCasting = (p, poly) => {
  var px = p.x
  var py = p.y
  var flag = false
  for (var i = 0, l = poly.length, j = l - 1; i < l; j = i, i++) {
    var sx = poly[i].x
    var sy = poly[i].y
    var tx = poly[j].x
    var ty = poly[j].y
    // 点与多边形顶点重合
    if ((sx === px && sy === py) || (tx === px && ty === py)) {
      return 'on'
    }
    // 判断线段两端点是否在射线两侧
    if ((sy < py && ty >= py) || (sy >= py && ty < py)) {
      // 线段上与射线 Y 坐标相同的点的 X 坐标
      var x = sx + (py - sy) * (tx - sx) / (ty - sy)
      // 点在多边形的边上
      if (x === px) {
        return 'on'
      }
      // 射线穿过多边形的边界
      if (x > px) {
        flag = !flag
      }
    }
  }
  // 射线穿过多边形边界的次数为奇数时点在多边形内
  return flag ? 'in' : 'out'
}
// 判断点p在当前多边形内部（包括边上）
commonJs.isPointInPolygon = (p, poly) => {
  var px = parseInt(p.x)
  var py = parseInt(p.y)
  let inside = false
  for (var i = 0, l = poly.length, j = l - 1; i < l; j = i, i++) {
    var sx = parseInt(poly[i].x)
    var sy = parseInt(poly[i].y)
    var tx = parseInt(poly[j].x)
    var ty = parseInt(poly[j].y)
    // 先检查点是否在线段上（包括端点）
    if (isPointOnSegment([sx, sy], [tx, ty], [px, py])) {
      return true; // 点在边上，直接返回true
    }
    // 标准的射线法判断（不考虑点在边上的情况）
    const intersect = ((sy > py) !== (ty > py)) && (px < (tx - sx) * (py - sy) / (ty - sy) + sx)

    if (intersect) inside = !inside
  }

  return inside
}
function isPointOnSegment(lineStart, lineEnd, point) {
    const [x1, y1] = lineStart
    const [x2, y2] = lineEnd
    const [x, y] = point

    // 使用向量叉积检查三点共线
    const crossProduct = (y2 - y1) * (x - x1) - (x2 - x1) * (y - y1)

    // 如果叉积不为0，说明三点不共线
    if (Math.abs(crossProduct) > Number.EPSILON) {
        return false
    }

    // 检查点是否在线段的边界框内
    const dotProduct = (x - x1) * (x2 - x1) + (y - y1) * (y2 - y1)
    const squaredLength = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1)

    // 点在线段上（包括端点）
    return dotProduct >= 0 && dotProduct <= squaredLength
}
commonJs.calcThrowRangeStyle = (width, range, value) => {
  let throwRangeWidth = (value.max - value.min) ? width * (value.max - value.min) / (range) : 1
  let throwRangeLeft = width * value.min / (range)
  return {
    width: throwRangeWidth + 'px',
    left: throwRangeLeft + 'px'
  }
}

commonJs.dataSort = (data, key) => {
  let tempArray = JSON.parse(JSON.stringify(data))
  return tempArray && tempArray.sort((obj1, obj2) => {
    return obj1.name.localeCompare(obj2[key])
  })
}
commonJs.dataSortByNumber = (data, key) => {
  let tempArray = JSON.parse(JSON.stringify(data))
  return tempArray && tempArray.sort((obj1, obj2) => {
    return obj1[key] - obj2[key]
  })
}

commonJs.findMatchingModelByConf = function (val) {
  let matchingModel = null
  matchingModel = Vue.prototype.ProjectorSpec.filter(
    item => {
      let key = 'c' + val
      return item[key]
    }
  )
  return matchingModel
}
commonJs.findMatchingModel = function (val) {
  let matchingModel = null
  matchingModel = Vue.prototype.ProjectorSpec.filter(
    item => {
      let cateVal = item.category
      switch (val) {
        case 0:
          return cateVal === 0 || cateVal === 1 || cateVal === 2
        case 1:
          return cateVal === 3 || cateVal === 4
        case 2:
          return cateVal === 6 || cateVal === 7
        case 3:
          return cateVal === 8
        case 4:
          return cateVal === 9
        case 5:
          return cateVal === 5
        default:
          break
      }
    }
  )
  return matchingModel
}

// 判断八边形，六边形，四边形
commonJs.octagon = function () {
  if (Store.state.position === 0) {
    if (Store.state.graph.vLensShift.max === Store.state.graph.vLensShift.min) {
      return ''
    } else if (Store.state.graph.vLensShift.min > 0 && Store.state.graph.hLensShift.max === Store.state.graph.hLensShift.min) {
      return 'quadrilateral'
    } else if (Store.state.graph.vLensShift.min > 0 && Store.state.graph.hLensShift.max !== Store.state.graph.hLensShift.min) {
      return 'hexagon'
    } else {
      return 'octagon'
    }
  } else if (Store.state.position === 1) {
    if (Store.state.graph.vLensShift.max === Store.state.graph.vLensShift.min) {
      return ''
    } else if (Store.state.graph.vLensShift.min < 0 && Store.state.graph.hLensShift.max === Store.state.graph.hLensShift.min) {
      return 'quadrilateral'
    } else if (Store.state.graph.vLensShift.max < 0 && Store.state.graph.hLensShift.max !== Store.state.graph.hLensShift.min) {
      return 'hexagon'
    } else {
      return 'octagon'
    }
  }
}

commonJs.checkRange = (value, min, max) => {
  if (value > max * 1) {
    value = max * 1
  } else if (value < min * 1) {
    value = min * 1
  }
  return value
}

commonJs.isIE = () => {
  var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
  if (isIE || isEdge) {
    return true
  } else {
    return false
  }
}

/**
 * 求圆和直线之间的交点
 * 直线方程：y = kx + b
 * 圆的方程：(x - m)² + (x - n)² = r²
 * x1, y1 = 线坐标1, x2, y2 = 线坐标2, m, n = 圆坐标, r = 半径
 */
commonJs.getInsertPointBetweenCircleAndLine = (x1, y1, x2, y2, m, n, r) => {
  // console.log(x1, y1, x2, y2, m, n, r)
  let kbArr = commonJs.binaryEquationGetKB(x1, y1, x2, y2)
  let k = kbArr[0]
  let b = kbArr[1]

  let aX = 1 + k * k
  let bX = 2 * k * (b - n) - 2 * m
  let cX = m * m + (b - n) * (b - n) - r * r

  let insertPoints = []
  let xArr = commonJs.quadEquationGetX(aX, bX, cX)
  xArr.forEach(x => {
    let y = k * x + b
    insertPoints.push({ x: x, y: y })
  })
  return insertPoints
}

/**
 * 求二元一次方程的系数
 * y1 = k * x1 + b => k = (y1 - b) / x1
 * y2 = k * x2 + b => y2 = ((y1 - b) / x1) * x2 + b
 */
commonJs.binaryEquationGetKB = (x1, y1, x2, y2) => {
  let k = (y1 - y2) / (x1 - x2)
  let b = (x1 * y2 - x2 * y1) / (x1 - x2)
  return [k, b]
}

/**
* 一元二次方程求根
* ax² + bx + c = 0
*/
commonJs.quadEquationGetX = (a, b, c) => {
  let xArr = []
  let result = Math.pow(b, 2) - 4 * a * c
  if (result > 0) {
    xArr.push((-b + Math.sqrt(result)) / (2 * a))
    xArr.push((-b - Math.sqrt(result)) / (2 * a))
  } else if (result === 0) {
    xArr.push(-b / (2 * a))
  }
  return xArr
}

// ax^2+bx+c=0
/**
 * 根据半径，弦长，求拱高
 */
commonJs.getDepthByRadiusChord = (radius, chord) => {
  let L = chord
  let r = radius
  let a = 4
  let b = -8 * r
  let c = Math.pow(L, 2)
  let disc = Math.pow(b, 2) - 4 * a * c

  let p = -b / (2 * a)
  let q = Math.sqrt(disc) / (2 * a)
  let depth1 = p + q
  let depth2 = p - q
  let depth = depth1 >= r ? depth2 : depth1
  return depth
}

// ax^2+bx+c=0
commonJs.curveRadiusToDepth = (radius) => {
  let L = commonJs.getChordLength()
  let r = radius
  let a = 4
  let b = -8 * r
  let c = Math.pow(L, 2)
  let disc = Math.pow(b, 2) - 4 * a * c

  let p = -b / (2 * a)
  let q = Math.sqrt(disc) / (2 * a)
  let depth1 = p + q
  let depth2 = p - q
  let depth = depth1 >= r ? depth2 : depth1
  return depth
}

commonJs.curveDepthToRadius = (depth) => {
  let L = commonJs.getChordLength()
  let radius = [Math.pow(L, 2) + 4 * Math.pow(depth, 2)] / (8 * depth)

  return radius
}

commonJs.curveRadiusToCentralAngle = (radius) => {
  let L = commonJs.getChordLength()
  let centralAngle = 2 * Math.asin(L / (2 * radius))

  return centralAngle
}
commonJs.curveCentralAngleToRadius = (angle) => {
  let L = commonJs.getChordLength()
  let radius = L / (2 * Math.sin(angle / 2))

  return radius
}
// commonJs.curveArcToRadius = (arc) => {
//   let L = commonJs.getChordLength()
//   let radius
//   // 求解sinx / x = L / arc x范围为
//   for (let i = 0; i < 180; i++) {
//     let p = i * (Math.PI / 180)
//     let q = (i + 1) * (Math.PI / 180)
//     let num = L / arc
//     let value = Math.sin(p) - num * p
//     let value1 = Math.sin(q) - num * q
//     if (value * value1 < 0) {
//       radius = 180 * arc / (2 * (i + 0.5) * Math.PI)
//       break
//     }
//   }
//   return radius
// }
commonJs.curveArcToRadius = (arc) => {
  let chord = commonJs.getChordLength()
  let arc2crd = arc / chord
  let centang = 4
  let incr = 4
  let ct = 0
  while (ct < 75) {
    let angratio = (centang) / (2 * Math.sin(centang / 2))
    if (angratio > arc2crd) {
      incr = incr / 2
      centang = centang - incr
    } else {
      incr = incr * 2
      centang = centang + incr
    };
    ct = ct + 1
  }
  let radius = (chord / 2) / (Math.sin(centang / 2))
  return radius
}
commonJs.getChordLength = () => {
  // let len = Store.state.curveShape === '1' ? Store.state.houseInfo.roomW : Store.state.houseInfo.roomH
  return Store.state.curveChordLength
}
/**
 * 根据 半径R，弦长L，求角度θ
 * θ = 2 * asin(L / (2 * R))
 * θ : 弧度为单位
 */
commonJs.curveRadiusAndChordLengthToCentralAngle = (radius, chordLength) => {
  let centralAngle = 2 * Math.asin(chordLength / (2 * radius))
  return centralAngle
}
/**
 * 根据 半径R，弧长s，求角度θ
 * θ = s / R
 * θ : 弧度为单位
 */
commonJs.curveRadiusAndArcToCentralAngle = (radius, arc) => {
  let centralAngle = arc / radius
  return centralAngle
}
/**
 * 根据 半径R，角度θ，求深度h
 * h = R * (1 - cos(θ/2))
 * θ : 弧度为单位
 */
commonJs.curveRadiusAndThetaToDepth = (radius, theta) => {
  let h = radius * (1.0 - Math.cos(theta / 2.0))
  return h
}
/**
 * 根据 半径R，角度θ，求弦长L
 * L = 2 * R * sin(θ / 2.0)
 * θ : 弧度为单位(0~π)(0°~180°)
 */
commonJs.curveRadiusAndThetaToChordLength = (radius, theta) => {
  let L = 2 * radius * Math.sin(theta / 2.0)
  return L
}
/**
 * 根据 半径R，深度h，求弦长L
 * L = sqrt(8 * R * h - 4 * h * h)
 * 必要条件: h <= 2R
 */
commonJs.curveRadiusAndDepthToChordLength = (radius, depth) => {
  let val = 8 * radius * depth - 4 * depth * depth
  let L = Math.sqrt(val)
  return L
}
/**
 * 根据 半径R，角度θ，求弧长s
 * s = R * θ
 * θ : 弧度为单位
 */
commonJs.curveRadiusAndThetaToArc = (radius, theta) => {
  let s = radius * theta
  return s
}
/**
 * 根据 深度h，角度θ，求半径R
 * R = h / (1 - cos(θ/2))
 * θ : 弧度为单位
 */
commonJs.curveDepthAndThetaToRadius = (depth, theta) => {
  let denom = (1.0 - Math.cos(theta / 2.0))
  let radius = depth / denom
  return radius
}
/**
 * 根据 弧长s，角度θ，求半径R
 * R = s / θ
 * θ : 弧度为单位
 */
commonJs.curveArcAndThetaToRadius = (arc, theta) => {
  let radius = arc / theta
  return radius
}
/**
 * 根据 深度h，弧长s，求角度θ
 * θ : 弧度为单位
 * θ*s/8 <= h <= s/π h （π h <= s <= 8h/θ）制限,保证不会发生ga * gb > 0
 */
commonJs.curveDepthAndArcToCentralAngle = (depth, arc) => {
  let h = depth
  let s = arc
  function g(theta) {
    return (s / theta) * (1.0 - Math.cos(theta / 2.0)) - h
  }

  let a = 1e-6
  let b = Math.PI - 1e-6
  let ga = g(a)
  let gb = g(b)
  if (ga * gb > 0) {
    return null
  }
  let theta
  for (let i = 0; i < 80; i++) {
    let m = 0.5 * (a + b)
    let gm = g(m)
    
    if (Math.abs(gm) < 1e-12) {
      theta = m
      break
    }

    if (ga * gm < 0) {
      b = m
      gb = gm
    } else {
      a = m
      ga = gm
    }
  }

  if (theta === undefined) {
    theta = 0.5 * (a + b)
  }

  return theta
}
commonJs.getBrightness = function () {
  let brightness = '-'
  let lensExchange = Store.state.selectedModelData.lensExchange
  if (lensExchange) {
    let code = Store.state.selectedModelData.code
    let lensId = Store.state.selectedLensData.id
    for (let i = 0; i < Vue.prototype.Brightness.optionLens.length; i++) {
      if (Vue.prototype.Brightness.optionLens[i].code === code && Vue.prototype.Brightness.optionLens[i].lensId === lensId) {
        brightness = Vue.prototype.Brightness.optionLens[i].brightness
        return brightness
      }
    }
  }
  //  else if (Store.state.aspectRatio === '16:6') { // ust 新规机能4
  //   return Store.state.selectedModelData.color * 0.67 + ''
  // } else if (Store.state.aspectRatio === '21:9') {
  //   return Store.state.selectedModelData.color * 0.76 + ''
  // }
  return Store.state.selectedModelData.color
}
commonJs.brightnessCoefficient = function () {
  let b = commonJs.getBrightness()
  // console.log('lcd.aspectRatio', Store.state.selectedLensData.lcd.aspectRatio)
  // console.log('aspectRatio', Store.state.aspectRatio)
  let lcdratio = Store.state.selectedLensData.lcd.aspectRatio.split(':')
  let ratio = Store.state.aspectRatio.split(':')
  let nowRatio = (Math.min(lcdratio[0] * ratio[1], lcdratio[1] * ratio[0]) / Math.max(lcdratio[0] * ratio[1], lcdratio[1] * ratio[0])).toFixed(4)
  return b.split('ml')[0] * nowRatio
  // if (Store.state.selectedLensData.lcd.aspectRatio === '16:10') {
  //   switch (Store.state.aspectRatio) {
  //     case '16:10' :
  //       return b.split('ml')[0] * 100 / 100
  //     case '16:9' :
  //       return b.split('ml')[0] * 90 / 100
  //     case '4:3' :
  //       return b.split('ml')[0] * 83.34 / 100
  //     case '21:9' :
  //       return b.split('ml')[0] * 68.6 / 100
  //     case '16:6':
  //       return b.split('ml')[0] * 60 / 100
  //     default :
  //       break
  //   }
  // } else if (Store.state.selectedLensData.lcd.aspectRatio === '16:9') {
  //   switch (Store.state.aspectRatio) {
  //     case '16:10' :
  //       return b.split('ml')[0] * 83.34 / 100
  //     case '16:9' :
  //       return b.split('ml')[0] * 100 / 100
  //     case '4:3' :
  //       return b.split('ml')[0] * 75 / 100
  //     case '21:9' :
  //       return b.split('ml')[0]
  //     case '16:6' :
  //       return b.split('ml')[0]
  //     case '2.35:1' :
  //       return b.split('ml')[0] * 75.6 / 100
  //     default :
  //       break
  //   }
  // } else if (Store.state.selectedLensData.lcd.aspectRatio === '4:3') {
  //   switch (Store.state.aspectRatio) {
  //     case '16:10' :
  //       return b.split('ml')[0] * 83.34 / 100
  //     case '16:9' :
  //       return b.split('ml')[0] * 75 / 100
  //     case '4:3' :
  //       return b.split('ml')[0] * 100 / 100
  //     default :
  //       break
  //   }
  // }
}
commonJs.brightnessCoefficientForBlending = function () {
  let b = commonJs.getBrightness()
  let lcdratio = Store.state.selectedLensData.lcd.aspectRatio.split(':')
  let ratio = Store.state.blendingParam.ratio.split(':')
  let nowRatio = (Math.min(lcdratio[0] * ratio[1], lcdratio[1] * ratio[0]) / Math.max(lcdratio[0] * ratio[1], lcdratio[1] * ratio[0])).toFixed(4)
  return b.split('ml')[0] * nowRatio
}
// 凹面
// radius:圆弧半径 td:throw distance len:投射到平面上的长度(垂直时是屏幕的高,水平时时屏幕的宽) depth:圆弧深度
commonJs.getConcaveCurveLength = function (radius, td, len, depth) {
  // let xc = 0
  let yc = td + depth - radius
  let xe = len / 2
  let ye = td
  let a = ye
  let b = xe * (-1)
  let L = Math.sqrt(Math.pow(xe, 2) + Math.pow(ye, 2))
  let ex = xe / L
  let ey = ye / L
  let vx = ey * (-1)
  let vy = ex
  let k = (b * yc) / (a * vx + b * vy) * (-1)
  let xp = k * vx
  // let yp = yc + (k * vy)
  let s = Math.sqrt(Math.pow(radius, 2) - Math.pow(k, 2))
  let x1 = xp + (s * ex)
  let length = Math.abs(x1 * 2)
  return length
}
// 凸面
// radius:圆弧半径 td:throw distance len:投射到平面上的长度(垂直时是屏幕的高,水平时时屏幕的宽)
commonJs.getConvexCurveLength = function (radius, td, len) {
  // let xc = 0
  let yc = td + radius
  let xe = len / 2
  let ye = td
  let a = ye
  let b = xe * (-1)
  let L = Math.sqrt(Math.pow(xe, 2) + Math.pow(ye, 2))
  let ex = xe / L
  let ey = ye / L
  let vx = ey * (-1)
  let vy = ex
  let k = (b * yc) / (a * vx + b * vy) * (-1)
  let xp = k * vx
  // let yp = yc + (k * vy)
  let s = Math.sqrt(Math.pow(radius, 2) - Math.pow(k, 2))
  let x2 = xp - (s * ex)
  let length = Math.abs(x2 * 2)
  return length
}

// 凹面
// radius:圆弧半径, d:弦长, td:throw distance
commonJs.getConcaveRLRatio = function (radius, d, td) {
  // スクリーン面までの投写距離Lを求める
  let L = td + (radius * (1 - Math.cos((2 * Math.asin(d / (2 * radius))) / 2)))
  // R / L
  let val = radius / L
  return val
}
// 凸面
// radius:圆弧半径, d:弦长, td:throw distance
commonJs.getConvexRLRatio = function (radius, d, td) {
  // スクリーン面までの投写距離Lを求める
  let L = td + (radius * (1 - Math.cos((2 * Math.asin(d / (2 * radius))) / 2)))
  // R / L
  let val = radius / L
  return val
}
// 屏幕的最前面（S1）和最里面（S2）是（每台屏幕的深度）
// arc: 每台的圆弧长度
commonJs.getScreenDepth = function (radius, arc) {
  // スクリーン面までの投写距離Lを求める
  let value = radius * (1 - Math.cos(arc / radius / 2))
  return value
}

// 判断当前屏幕是否是曲面
commonJs.isCurFace = function () {
  if (Store.state.searchTabActive === 'CurvedSurface' && Store.state.curveDepth !== 0) {
    return true
  }
  return false
}

commonJs.matchRange = function (target, max, min) {
  let result = true
  if (min && max === '' && target * 1 < min * 1) {
    result = false
  }
  if (max && min === '' && target * 1 > max * 1) {
    result = false
  }
  if (max && min && (target * 1 > Math.max(max, min) || target * 1 < Math.min(max, min))) {
    result = false
  }
  return result
}

commonJs.SimpleDisable = function (isUstNotWallToSimple, isSimpleUstWallToAdvance) {
  if (!isUstNotWallToSimple && !isSimpleUstWallToAdvance) {
    Store.commit('SET_VLENSSHIFT', 0)
  }

  Store.commit('SET_HLENSSHIFT', 0)
  Store.commit('SET_OFFSET', 0)
  Store.commit('SET_HANGLEFLAG', false)
  Store.commit('SET_VANGLEFLAG', false)
  Store.commit('SET_SCREENSIZECHECKED', false)
  Store.commit('SET_THROWDISTANCECHECKED', false)
  Store.commit('SET_REALTHROWDISTANCECHECKED', false)
  Store.commit('ROOMW', 1000)
  Store.commit('ROOMH', 500)
  Store.commit('ROOMD', 2000)
  Store.commit('SET_ISOUTOFSPEC', false)
  Store.commit('SET_OUTOFSPECVAL', false)
  if (isSimpleUstWallToAdvance) {
    Store.commit('ROOMH', 300)
  }
}

commonJs.getBoardTop = function () {
  let boardStatusTop
  let screenTop = Store.state.drawData[0][0].z
  if (Store.state.fingerTouchStatus && Store.state.FTULocationState) {
    let fixedHeight = Store.state.graph.scrnH + (Store.state.FTUT2screenT + Store.state.board2screenH)
    boardStatusTop = screenTop - (Store.state.graph.boardH - fixedHeight) / 2 - Store.state.FTUT2screenT
  } else if (Store.state.fingerTouchStatus && !Store.state.FTULocationState) {
    boardStatusTop = screenTop - Store.state.board2screenH
  } else {
    let fixedHeight = Store.state.graph.scrnH + Store.state.board2screenH * 2
    boardStatusTop = screenTop - (Store.state.graph.boardH - fixedHeight) / 2 - Store.state.board2screenH
  }
  if (boardStatusTop < 0) boardStatusTop = 0
  let floor2bottom = Store.state.houseInfo.roomH - (boardStatusTop + Store.state.graph.boardH)
  if (floor2bottom <= 0) {
    floor2bottom = 0
    boardStatusTop = Store.state.houseInfo.roomH - Store.state.graph.boardH
  }
  let plateTopToCeilingVal = Store.state.graph.pjZ - Store.state.selectedLensData.lens2mptsHeight + Store.state.selectedLensData.mpts2wallBottomHeight - Store.state.selectedModelData.wallHeight / 10
  let wallPlateHeightVal = Store.state.selectedModelData.wallHeight / 10
  let plateBottomToScreenVal = Store.state.drawData[0][0].z - Store.state.graph.pjZ + Store.state.selectedLensData.lens2mptsHeight - Store.state.selectedLensData.mpts2wallBottomHeight
  let touchInstall = (boardStatusTop - (plateTopToCeilingVal + wallPlateHeightVal)).toFixed(1) * 1 >= (plateBottomToScreenVal - Store.state.board2screenH).toFixed(1) * 1
  Store.commit('SET_TOUCHINSTALL', touchInstall)
  Store.commit('SET_BOARDSTATUSTOP', boardStatusTop)
  Store.commit('SET_FLOOR2BOTTOM', floor2bottom)
}

// 因为再 main.js 中 selectedModelData.name 的内容改称为了 name_code，所以 画面表示时，需要将其还原
commonJs.getModelLabelByName = function (modelName) {
  const parts = modelName.split('_')
  if (parts.length > 1) {
    parts.pop()
  }
  return parts.join('_')
}

export default commonJs

export function getMatchingLensById (lenses, size) {
  const tempArray = []
  lenses.forEach(element => {
    Vue.prototype.OptionLensSpec.forEach((item) => {
      if (item.id === element && item.lcdSize === size) {
        tempArray.push({
          id: item.id,
          name: item.name
        })
      }
    })
  })
  return tempArray
}



// WEBPACK FOOTER //
// ./src/common/common.js